module.exports = __webpack_public_path__ + "media/klaseaDia1Barco4.2d75efc7.mp4";